import React, { useEffect, useState } from "react";
import "./WelcomeCard.css";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { useBackground } from '../context/BackgroundContext'; 

// Import both images
import welcomeBg from '../assets/background.jpg'; // Desktop
import welcomeBgMobile from '../assets/background_phone.jpg'; // Phone (Rename to your actual file)

const WelcomeCard = () => {
  const navigate = useNavigate();
  const { changeBackground } = useBackground();
  
  // State to track if we are on mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  // Listener to handle resizing (e.g. rotating phone)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Update background whenever 'isMobile' changes
  useEffect(() => {
    changeBackground(isMobile ? welcomeBgMobile : welcomeBg); 
  }, [changeBackground, isMobile]);

  return (
    <Layout>
        {/* We add a container-wrapper to help with positioning if needed */}
        <div className="welcome-container">
            <button onClick={() => navigate("/agent-login")} className="welcome-action-button" >
              GO AHEAD
            </button>
        </div>
    </Layout>
  );
};

export default WelcomeCard;